import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { Conditions, DataTypes, Displays } from '../../domain/Constants';
import { Combobox } from '../ui/combobox';
import { Input } from '../ui/input';

export function SortableSection({ section, index, formik, removeItem }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: section.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const handleRemoveItem = (e) => {
        e.preventDefault();
        removeItem(index);
    };

    if (formik.values?.sections === null || formik.values?.sections[index] === null) {
        return null;
    }

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                    <label className="text-sm font-medium">Name</label>
                    <Input
                        data-no-dnd="true"
                        type="text"
                        name={`sections.${index}.name`}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sections[index]?.name || ''}
                        placeholder="Section name"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium">Data Type</label>
                    <Combobox
                        options={DataTypes}
                        value={formik.values.sections[index]?.dataType}
                        onChange={selected => formik.handleChange(`sections.${index}.dataType`)(selected.value)}
                        onBlur={formik.handleBlur}
                        placeholder="Select data type"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                    <label className="text-sm font-medium">Condition</label>
                    <Combobox
                        options={Conditions}
                        value={formik.values.sections[index]?.condition}
                        onChange={selected => formik.handleChange(`sections.${index}.condition`)(selected.value)}
                        onBlur={formik.handleBlur}
                        placeholder="Select condition"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium">Display</label>
                    <Combobox
                        options={Displays}
                        value={formik.values.sections[index]?.display}
                        onChange={selected => formik.handleChange(`sections.${index}.display`)(selected.value)}
                        onBlur={formik.handleBlur}
                        placeholder="Select display"
                    />
                </div>
            </div>

            <div className="space-y-2">
                <label className="text-sm font-medium">Description</label>
                <Input
                    data-no-dnd="true"
                    type="text"
                    name={`sections.${index}.description`}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.sections[index]?.description || ''}
                    placeholder="Section description"
                />
            </div>
        </>
    );
}